import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Icon as AlertIcon } from '../../../components';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';

interface IProps {
  message: string;
  style?: any;
}

export const WarningMessage: FunctionComponent<IProps> = ({ message, style }) => (

  <View style={[styles.container, style]}>
    <AlertIcon
      size={defaultScale(35)}
      color={Theme.GREY_MEDIUM}
      name='ios-alert-outline'
      style={{ paddingRight: defaultScale(10) }}
    />
    <Text style={styles.warningText}>{message}</Text>
  </View>
);

const styles = StyleSheet.create({
  warningText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
    paddingBottom: defaultScale(4),
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
